export function Step1PersonaSection() {
  return (
    <section className="border-y border-ink-100 bg-ink-50/60">
      <div className="mx-auto grid max-w-[1200px] grid-cols-1 items-center gap-12 px-6 py-24 lg:grid-cols-[minmax(0,420px)_minmax(0,1fr)]">
        <div>
          <span className="inline-flex items-center gap-1 rounded-md bg-brand-50 px-2.5 py-1 text-[11px] font-bold tracking-wider text-brand-700">
            STEP 1
          </span>
          <h3 className="mt-5 text-[34px] font-bold leading-[1.25] tracking-tight md:text-[40px]">
            <span className="whitespace-nowrap">ペルソナ設計</span>
            <br />
            <span className="text-[24px] font-semibold text-ink-700 md:text-[28px]">
              <span className="whitespace-nowrap">自社の募集要項をAIが分析して</span>
              <br />
              <span className="whitespace-nowrap">ペルソナを設計</span>
            </span>
          </h3>
          <p className="mt-5 text-[14px] leading-relaxed text-ink-600">
            役割・スキル・経験などの条件を整理し、
            <br />
            スカウトの精度と効率を高めます。
          </p>
          <div className="mt-6 inline-flex h-10 items-center gap-2 rounded-full border border-ink-200 bg-white px-4 text-[13px] text-ink-700">
            <span className="mi text-[16px] text-brand-600">auto_awesome</span>
            スカウト精度をあげるペルソナをAIが提案
          </div>
        </div>

        <div>
          <img
            alt="AIが募集要項から複数のペルソナ案を生成する図解"
            className="w-full rounded-2xl bg-white shadow-card ring-1 ring-ink-200/60"
            src="/images/lp/step1-persona-abstract-source.svg"
          />
        </div>
      </div>
    </section>
  );
}
